module.exports = __webpack_public_path__ + "img/josei_mezame.450416ae.jpg";